import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      //首页
      path: '/index',
      name: 'Index',
      component: () => import('@/pages/index/Index'),
      alias:'/',
      meta : {
        title : '钛刻专家——官网'
      },
    }, {
      //登录，注册，忘记密码，模板
      path: '/UserLayout',
      name: 'UserLayout',
      component: () => import('@/pages/user/Layout'),
      redirect:'/',
      children: [
        {
          //登录
          path: 'Login',
          name: 'Login',
          component: () => import('@/pages/user/Login'),
          alias:'/Login',
          meta : {
            title : '登录'
          },
        }, {
          //注册
          path: 'Register',
          name: 'Register',
          component: () => import('@/pages/user/Register'),
          alias:'/Register',
          meta : {
            title : '注册'
          },
        }, {
          //忘记密码
          path: 'Forget',
          name: 'Forget',
          component: () => import('@/pages/user/Forget'),
          alias:'/Forget',
          meta : {
            title : '忘记密码'
          },
        }, {
          //重置密码
          path: 'ResetPassword',
          name: 'ResetPassword',
          component: () => import('@/pages/user/ResetPassword'),
          alias:'/ResetPassword',
          meta : {
            title : '重置密码'
          },
        }, {
          //绑定手机
          path: 'BindTelPhone',
          name: 'BindTelPhone',
          component: () => import('@/pages/user/BindTelPhone'),
          alias:'/BindTelPhone',
          meta : {
            title : '绑定手机'
          },
        }
      ]
    },{
      //我的文档
      path: '/file',
      name: 'Navigate',
      component: () => import('@/pages/about/navigate'),
      meta : {
        login_require : true,
        expert_require : true,

        title : '个人中心'
      },
      children: [{
        //上传文档
        path: '/file/edit_document',
        name: 'Edit_document',
        alias:'/file/uploadoc',
        component: () => import('@/pages/document/edit_document'),
        meta : {
          login_require : true,
          expert_require : true,
          title : '上传文档'
        },
      },{
        //文档--我的草稿
        path: '/file/outline',
        name: 'Outline_list',
        component: () => import('@/pages/document/outline_list'),
        meta : {
          login_require : true,
          expert_require : true,
          title : '我的草稿'
        },
      },{
        //文档--我的待审核
        path: '/file/pending',
        name: 'Pending_list',
        component: () => import('@/pages/document/pending_list'),
        meta : {
          login_require : true,
          expert_require : true,
          title : '我的待审核'
        },
      },{
        //文档--我的发布
        path: '/file/publish',
        name: 'Publish_list',
        component: () => import('@/pages/document/publish_list'),
        meta : {
          login_require : true,
          expert_require : true,
          title : '我的发布'
        },
      },{
        //文档--我的被拒
        path: '/file/rejected',
        name: 'Rejected_list',
        component: () => import('@/pages/document/rejected_list'),
        meta : {
          login_require : true,
          expert_require : true,
          title : '我的被拒'
        },
      }]
    },{
      //协议部分
      path: '/ALayout',
      name: 'ALayout',
      component: () => import('@/pages/agreements/Layout'),
      redirect:'/',
      children:[
        {
          //钛刻专家协议
          path: 'Agreement',
          name: 'Agreement',
          component: () => import('@/pages/agreements/Agreement'),
          alias:'/Agreement',
          meta : {
            title : '钛刻专家协议'
          },
        },{
          //钛刻专家用户隐私政策
          path: 'Privacy',
          name: 'Privacy',
          component: () => import('@/pages/agreements/Privacy'),
          alias:'/Privacy',
          meta : {
            title : '钛刻专家用户隐私政策'
          },
        },
        {
          //钛刻专家发布文档声明
          path: 'release',
          name: 'Release',
          component: () => import('@/pages/agreements/docRelease'),
          alias:'/Release',
          meta : {
            title : '发布文档说明'
          },
        }
      ]
    },{
      //匹配404页面
      path: "/404",
      name: "notFound",
      component: () => import('@/pages/404'),
    },{
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    },{
      path: "/Guide", // 此处需特别注意置于最底部
      name: "Guide",
      component: () => import('@/pages/guide'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {x: 0, y: 0}
  }
});


router.beforeEach((to, from, next) => {
  let title = to.meta.title;//网页的title
  let login_require = to.meta.login_require;//是否需要验证登录
  let expert_require = to.meta.expert_require;//是否需要验证是否是专家身份
  let user_info = JSON.parse(localStorage.getItem('user_info'));
  document.title = title || '';
  if(login_require){
    if ( user_info === null){
      next('/Login')
    } else {
      next()
    }
  }else {
    next()
  }
  if(expert_require){
    if(user_info.expert_status.isExpert){
      next()
    }else{
      next('/Guide')
    }
  }else{
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js